<div class="order__location">
  <div>
    <ion-icon src="../../assets/icon/location.svg"></ion-icon>
  </div>
  <div class="container-address">
    <p class="address">{{ data.order.client.getAddress() }}</p>
  </div>
</div>
<div class="order">
  <div>
    <p class="order__time"> Besteld om <span class="time__value">{{ data.order.order.placedAt | date: 'H:mm' }}</span>
    </p>
    <p class="order__name"> Bestelling voor {{ data.order.client.name }}</p>
    <p class="order__payment-type"> {{ data.order.order.paymentType }} <span *ngIf="data.order.order.paymentComplete">-
        Betaald</span> </p>
  </div>
  <div class="order__list" #orderListWrapper (scroll)="onScroll()">
    <ion-list>
      <ion-item *ngFor="let orderLine of data.order.order.orderLines" class="order__item">
        <img src="../../../../assets/icon/pizza.png" />
        <p class="order__item-text">{{ orderLine.count }} x {{ orderLine.article }} {{ orderLine.size }} - {{
          orderLine.price | currency: 'EUR' }}</p>
      </ion-item>
    </ion-list>
    <div *ngIf="showGradient" class="order__list-shadow"></div>
  </div>
  <p class="order__total">TOTAAL: {{(data.order.order.paymentComplete ? 0 : data.order.order.totalPrice)| currency:
    'EUR'}} </p>
  <div class="order__contact-buttons">
    <ion-icon src="../../assets/icon/phone-circle.svg" (click)="callOrder($event, data.order)"></ion-icon>
    <ion-icon src="../../assets/icon/message-circle.svg"
      (click)="sendSms($event, data.order.id, data.order.client.telephoneNumber, data.order.client.getAddress())"></ion-icon>
    <ion-icon src="../../assets/icon/navigation-circle.svg" (click)="startNavigation($event, data.order)"></ion-icon>
  </div>

</div>
<div class="action-buttons">
  <ion-button *ngIf="data.order.order.isInDelivery" (click)="endDelivery(data.order)">
    Bestelling afleveren
  </ion-button>
  <ion-button *ngIf="data.order.order.isReadyForDelivery" (click)="passOnOrder()" class="pass-on">
    Doorgeven
    <ion-icon slot="start" src="../../assets/icon/export.svg"></ion-icon>
  </ion-button>
  <ion-button *ngIf="data.order.order.isReadyForDelivery" class="go" (click)="startDelivery(data.order.id)"
    [disabled]="orderService.hasOrdersInDelivery() || isStartingDelivery">
    <ion-spinner name="crescent" *ngIf="isStartingDelivery"></ion-spinner>
    <span class="content" *ngIf="!isStartingDelivery">
      <ion-icon slot="start" src="../../assets/icon/bicycle.svg"></ion-icon>
      <div>Go</div>
    </span>
  </ion-button>
</div>